'use client'

import { useQuery } from '@tanstack/react-query'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

import { useSharedTRPC } from '../../context'

interface NotificationBadgeProps {
  className?: string
}

/**
 * Counts RECIPIENT-audience unread only — see decision 8 in the spec. That filtering
 * happens server-side (`BADGE_AUDIENCE` in the router); this component just renders
 * the number and hides at zero.
 *
 * `refetchOnWindowFocus` is the Phase 1 stand-in for realtime; a service worker
 * push channel replaces it in a later phase.
 */
export function NotificationBadge({ className }: NotificationBadgeProps) {
  const trpc = useSharedTRPC()
  const { data } = useQuery({
    ...trpc.notification.unreadCount.queryOptions(),
    refetchOnWindowFocus: true,
  })

  const count = data?.count ?? 0
  if (count === 0) return null

  return (
    <span
      className={cn(
        typographyVariants({ variant: 'label-sm' }),
        'srd:bg-error srd:text-neutral-white srd:flex srd:size-5 srd:items-center srd:justify-center srd:rounded-full',
        className,
      )}
      aria-label={`${count} pesan belum dibaca`}
    >
      {count > 99 ? '99+' : count}
    </span>
  )
}
